import { useLang } from '@/i18n';
import styled from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
// import { Tabs } from 'antd-v5';
import { useState } from 'react';

// const { TabPane } = Tabs;

export default function BreakLimits() {
    const { t } = useLang('theProduct.BreakLimits');
    const [active, setActive] = useState('ultra');
    const tabList = [
        {
            key: 'ultra',
            label: t('limits_tab1'),
            stepList: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747222727909/STREAM%20Ultra-sp.png',
                    title: t('limits_tab1_title1'),
                    desc: t('limits_tab1_desc1'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747122631031/the%20STREAM%20Ultra%20Series.png',
                    title: t('limits_tab1_title2'),
                    desc: t('limits_tab1_desc2'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747122644977/Plug%20%26%20Play.png',
                    title: t('limits_tab1_title3'),
                    desc: t('limits_tab1_desc3'),
                },
            ],
        },
        {
            key: 'ac',
            label: t('limits_tab2'),
            stepList: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747122700966/STREAM%20micro-%20inverter.png',
                    title: t('limits_tab2_title1'),
                    desc: t('limits_tab2_desc1'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747222738862/ac%20pro.png',
                    title: t('limits_tab2_title2'),
                    desc: t('limits_tab2_desc2'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747122644977/Plug%20%26%20Play.png',
                    title: t('limits_tab2_title3'),
                    desc: t('limits_tab2_desc3'),
                },
            ],
        },
        {
            key: 'stream',
            label: t('limits_tab3'),
            stepList: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747122569629/Solar%20Panels.png',
                    title: t('limits_tab3_title1'),
                    desc: t('limits_tab3_desc1'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747122727309/STREAM%20micro-%20inverter-1.png',
                    title: t('limits_tab3_title2'),
                    desc: t('limits_tab3_desc2'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747122742649/Plug%20%26%20Play-1.png',
                    title: t('limits_tab3_title3'),
                    desc: t('limits_tab3_desc3'),
                },
            ],
        },
    ];

    return (
        <div className={styled.BreakLimits}>
            <EcoSpace hPad="100px" />
            <p className="limits-label">{t('limits_label')}</p>
            <p className="limits-title">{t('limits_title')}</p>
            <div className="limits-box">
                {tabList
                    .find((item) => item.key === active)
                    ?.stepList.map((stepItem, stepIndex) => (
                        <div className="limits-item" key={stepIndex}>
                            <EcoImg className="limits-img" pc={stepItem.img} />
                            <div className="right">
                                <div className="limits-mobile-title">
                                    <div className="limits-number">{stepIndex + 1}</div>
                                    <p className="limits-title">{stepItem.title}</p>
                                </div>
                                <p className="limits-desc">{stepItem.desc}</p>
                            </div>
                        </div>
                    ))}
            </div>
            {/* <Tabs className="bonus_tabs" activeKey={active} onChange={(val) => setActive(val)} centered>
                {tabList.map((item) => (
                    <TabPane tab={item.label} key={item.key} />
                ))}
            </Tabs> */}
            <div className="swiper-tabs-box">
                <div className="swiper-tabs">
                    {tabList.map((item) => {
                        return (
                            <div key={item.key} className={`swiper-tabs__item ${item.key === active ? 'active' : ''}`} onClick={() => setActive(item.key)}>
                                {item.label}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
